import React from "react";
import { TIPOS_PERSONAL, TIPOS_CONTRATACION } from "../constants/rrhh";

export default function EmpleadosFilters({ filtros, setFiltros, limpiarFiltros }) {
  const hayFiltros =
    filtros.search || filtros.tipo_personal !== "all" ||
    filtros.tipo_contratacion !== "all" || filtros.estado !== "all";

  return (
    <div className="management-card emp-filters-card mb-4">
      <div className="row g-3 align-items-end">
        <div className="col-md-4">
          <label className="form-label management-label">Buscar</label>
          <div className="input-group">
            <span className="input-group-text bg-white border-end-0">
              <i className="bi bi-search text-muted" />
            </span>
            <input
              type="text"
              className="form-control border-start-0"
              placeholder="Nombre, apellido, cédula..."
              value={filtros.search}
              onChange={(e) => setFiltros((prev) => ({ ...prev, search: e.target.value }))}
            />
          </div>
        </div>

        <div className="col-md-2">
          <label className="form-label management-label">Tipo personal</label>
          <select
            className="form-select"
            value={filtros.tipo_personal}
            onChange={(e) => setFiltros((prev) => ({ ...prev, tipo_personal: e.target.value }))}
          >
            <option value="all">Todos</option>
            {TIPOS_PERSONAL.map((t) => (
              <option key={t.value} value={t.value}>{t.label}</option>
            ))}
          </select>
        </div>

        <div className="col-md-2">
          <label className="form-label management-label">Contratación</label>
          <select
            className="form-select"
            value={filtros.tipo_contratacion}
            onChange={(e) => setFiltros((prev) => ({ ...prev, tipo_contratacion: e.target.value }))}
          >
            <option value="all">Todas</option>
            {TIPOS_CONTRATACION.map((t) => (
              <option key={t.value} value={t.value}>{t.label}</option>
            ))}
          </select>
        </div>

        <div className="col-md-2">
          <label className="form-label management-label">Estado</label>
          <select
            className="form-select"
            value={filtros.estado}
            onChange={(e) => setFiltros((prev) => ({ ...prev, estado: e.target.value }))}
          >
            <option value="all">Todos</option>
            <option value="activo">Activo</option>
            <option value="inactivo">Inactivo</option>
          </select>
        </div>

        {hayFiltros && (
          <div className="col-md-2">
            <button type="button" className="btn btn-outline-secondary w-100" onClick={limpiarFiltros}>
              <i className="bi bi-x-circle me-2" />
              Limpiar
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
